/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.4",
    versionName: "0.2.0-nightly.2025.7.4",
    versionChannel: "nightly",
    buildDate: "2025-07-04T00:07:49.772Z",
    commitHash: "11c6c99b8dccec07184000513233508a69027547",
};
